export default function ReleveBonsConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('releve.bons');
}

ReleveBonsConfiguration.$inject = ['$translatePartialLoaderProvider'];
